import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Grid, Container } from '@mui/material';
import Header from '../components/autenticacao/Header';

const RootStyle = styled('div')(({ theme }) => ({
	height: '100%',
}));

export default function MainLayout() {
	return <RootStyle>
		<Grid container justifyContent='center'>
			<Grid item xs={12} md={4}>
				<Container sx={{ textAlign: 'center' }}>
					<Header />
					<Outlet />
				</Container>
			</Grid>
		</Grid>
	</RootStyle>
}
